import React, { Component } from 'react';
import PropertySearch from "../PropertySearch/PropertySearch.jsx";
import StepBar from "../StepBar/StepBar";
import Step from "../Step/Step";
import DataAddition from "../DataAddition/DataAddition";
import Payment from "../Payment/Payment";

export default class Insurance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step1: true,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            dataStep1: {},
            dataStep2: {},
            lang: this.props.match.params.lang === 'en' ? 2 : 1
        };
    
    }

    updateStates = (active_state, data = false) => {

        let state = {
            'step1': active_state === 'step1',
            'step2': active_state === 'step2',
            'step3': active_state === 'step3',
        };

        if (data) {
            state = { ...state, ...data }
        }

        this.setState(state)
    };

    render() {
        let content = null;
        switch (true) {
            case this.state.step2:
                content = <DataAddition
                    lang={this.state.lang}
                    dataState={this.state.dataStep2}
                    token={this.state.dataStep1.token}
                    startDate={this.state.dataStep1.suggestedStartDate}
                    onSubmit={(event) => this.updateStates('step3', { 'dataStep2': event })}
                    onPrevious={() => this.updateStates('step1')}
                />;
                break;
            case this.state.step3:
                content = <Payment
                    lang={this.state.lang}
                    onPrevious={() => this.updateStates('step2')}
                    data1={this.state.dataStep1} data2={this.state.dataStep2} />;
                break;
            default:
                content = <PropertySearch
                    lang={this.state.lang}
                    dataState={this.state.dataStep1}
                    onSubmit={(event) => this.updateStates('step2', { 'dataStep1': event })} />;
        }
        return (
            <div className="property_search">
                <div className="row align-center">
                    <div className="column small-12">
                        <StepBar>
                            <Step inner="1" active={this.state.step1} />
                            <Step inner="2" active={this.state.step2} />
                            <Step inner="3" active={this.state.step3} />
                            <Step inner="4" active={this.state.step4} />
                            <Step inner="5" active={this.state.step5} />
                        </StepBar>
                    </div>

                    {content}
                </div>
            </div>
        );
    }


}
